import { getCached, cacheResult } from './localCache';
import { get } from 'lodash';
import notify from './notify';
import * as types from '../constants/actionTypes';

// Cached Service call Wrapper
export const cacheCall = (api, method, path, name, init_args = {}, cache_ms = 0, variables ) => {
  const {init, success} = actionTypes(name);
  return dispatch => {
    // Check cache...
    const cache_key = 'api_call_' + method + '_' + path + JSON.stringify(variables);
    const data = getCached( cache_key );
    if (data) {
      // dispatch init and success events
      dispatch({type: init, ...init_args, fromCache: true});
      return dispatch({type: success, data});
    }
    // Not cached - run the call as we normally would
    return wrapCall( api[method](path, variables), name, 'fetch', init_args)( dispatch ).then( resp => {
      // API call complete, cache the results
      if (cache_ms > 0 && resp && resp.data) {
        cacheResult(cache_key, resp.data, cache_ms);
      }
    });
  };
};

// Service call wrapper
// returns 'thunk' function that wraps service calls with fetch notifications (init, success, failure)
// Handles traditionally caught errors as well as apisauce 'problems'
// 'action_type' is used to generate init, success, and failure action types
export const wrapCall = (promise, action_type, init_args = {}) => {
  return dispatch => {
    const {init, success, fail} = actionTypes(action_type);
    dispatch({type: init, promise, ...init_args});
    return promise
      .then(resp => {
        // check for valid response
        if (resp && resp.ok) {
          return dispatch({type: success, data: resp.data, headers: resp.headers, ...init_args});

          //suppress notification on 404 errors, which are expected from the API
        } else if (resp.status === 404) {
          return dispatch({type: fail, data: resp.data, headers: resp.headers, error: resp.problem, ...init_args});
        } else if (resp.status === 401) {
          return dispatch({
            type: types.UNAUTHORIZED,
            error: resp.problem,
            data: resp.data,
            status: resp.status,
            headers: resp.headers, ...init_args
          });
          //all other errors get reported
        } else {
          // Unified apisauce errors flow through here
          let message = resp.problem ? resp.problem : resp;
          if (get(init_args, 'showErrorToaster', true)) {
            notify.error( message.toLowerCase().replace('_', ' ') );
          }
          return dispatch({type: fail, data: resp.data, headers: resp.headers, error: resp.problem, ...init_args});
        }
      })
      .catch(error => {
        // Output the error if we're not in test mode, since during
        // tests we don't make real API calls.
        if (typeof(jest) === 'undefined') {
          console.error(error);
        }
        // redux and other errors come here
        dispatch({type: fail, error: error, ...init_args});
      });
  };
};

// async action type template
// ex:
// const { init , success, fail } = actionTypes('THING')
export const actionTypes = (prefix = 'fetch_data') => {
  prefix = prefix.toUpperCase();
  return {
    init: prefix,
    success: prefix + '_SUCCESS',
    fail: prefix + '_FAILURE'
  };
};



// WEBPACK FOOTER //
// ./src/utils/serviceUtils.js